/** Weeks spanned by a date range (ceiling, min 1). */
export function planWeeks(startDate: string, endDate: string): number {
  const ms = new Date(endDate).getTime() - new Date(startDate).getTime();
  return Math.max(1, Math.ceil(ms / (7 * 24 * 60 * 60 * 1000)));
}

/** Days from today until endDate. Negative = already past. */
export function daysUntil(endDate: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  return Math.ceil((end.getTime() - today.getTime()) / (24 * 60 * 60 * 1000));
}

/** "15 ene – 23 feb" or just "15 ene" if no endDate. */
export function formatRange(startDate: string, endDate?: string | null): string {
  const fmt = (d: string) =>
    new Date(d).toLocaleDateString('es-AR', { day: 'numeric', month: 'short' });
  return endDate ? `${fmt(startDate)} – ${fmt(endDate)}` : fmt(startDate);
}
